module.exports = __webpack_public_path__ + "img/banner.a38ad4ee.png";